const axios = require('axios');

import isLoggedIn from "../../../components/isLoggedIn";
import {FAV_LOCAL, FAV_URL_SAVE} from "../consts";

export default (json) => {
    if (isLoggedIn()) {
      axios.post(FAV_URL_SAVE, { products: json }, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

    } else {
        window.localStorage.setItem(FAV_LOCAL, JSON.stringify(json));
    }

}
